import React from 'react';
import theme from '../Admin.scss';
import {getMessage as msg} from 'MessageBundle'
import BaseComponent from 'common/BaseComponent';
import Table from 'common/Table';
import Select from 'common/Select';
import deleteIcon from './delete.png';
import inactiveIcon from './inactive.png';
import newItemIcon from './newItem.png';
import filterIcon from './filter.png';
import clearFilterIcon from './clearFilter.png';
import classnames from 'classnames';
import update from 'immutability-helper';
import {ValidationResult, validate, required, generateStrategyResult, focusFirstError} from 'validation';
import conf from 'configuration.json';
import ProgressBar from 'common/ProgressBar';
import ErrorBox from 'common/ErrorBox'
export default class RelationshipTab extends BaseComponent {

    constructor(props) {
        super(props);

        this.validation = this.getValidation();

        this.state = {
            processing: false,
            dataChanged: false,
            relationships:  [],
            types: new Map(),
            reasons: new Map(),
            causes: new Map(),
            products: new Map(),
            type: "",
            reason: "",
            cause: "",
            product:"",
            filterApplied : false,
            errorMessages: {}
        };

        this.firstRowStructure = [

            {
                attribute: "status", label: msg("admin.relationshipTab.status"), width: '70px', bodyStyle: theme.txtCenter,
                render: () => {
                    return (
                      ''
                    );
                }
            },
            {
                attribute: "type", label: msg("admin.relationshipTab.type"), width: '242px',
                render: (row ) => {
                    return (
                        <Select id={"type-select"} value={this.state.type} options={this.state.types} name="type" errorMessages={this.state.errorMessages}
                            onChange={this.handleChange('type')}  emptyValue={""} showExclamationMark={false}/>
                    );
                }
            },

            {
                attribute: "reason", label: msg("admin.relationshipTab.reason"), width: '242px',
                render: (row) => {
                    return (
                        <Select id={"reason-select"} value={this.state.reason} options={this.state.reasons} name="reason" errorMessages={this.state.errorMessages}
                            onChange={this.handleChange('reason')}  emptyValue={""} showExclamationMark={false}/>
                    );
                }
            },

            {
                attribute: "cause", label: msg("admin.relationshipTab.cause"), width: '242px',
                render: (row) => {
                    return (
                        <Select id={"cause-select"} value={this.state.cause} options={this.state.causes} name="cause" errorMessages={this.state.errorMessages}
                            onChange={this.handleChange('cause')}  emptyValue={""} showExclamationMark={false}/>
                    );

                }
            },

            {
                attribute: "product", label: msg("admin.relationshipTab.product"), width: '242px',
                render: (row) => {
                    return (
                        <Select id={"product-select"} value={this.state.product} options={this.state.products} name="product" errorMessages={this.state.errorMessages}
                            onChange={this.handleChange('product')}  emptyValue={""} showExclamationMark={false}/>
                    );
                }
            },

            {
                attribute: "action", label: msg("admin.relationshipTab.columnAction"), width: '130px', headStyle: theme.columnAction, bodyStyle: theme.columnAction,
                render: () => {
                    return (
                        <div>
                            <a href="javascript:void(0)" onClick={this.handleNewRowClick} title={msg("admin.relationshipTab.addRow")}>
                                <img src={newItemIcon} alt=""/>
                            </a>
                            <a href="javascript:void(0)" onClick={this.applyFilter} title={msg("admin.relationshipTab.applyFilter")}>
                                <img src={filterIcon} alt=""/>
                            </a>
                            <a href="javascript:void(0)" onClick={this.clearFilter} title={msg("admin.relationshipTab.clearFilter")}>
                                <img src={clearFilterIcon} alt=""/>
                            </a>
                        </div>
                    );
                }
            }

            ];

        this.tableStructure = [
            {
                attribute: "status", label: msg("admin.relationshipTab.status"), width: '70px', bodyStyle: theme.txtCenter,
                render: (row) => {
                    return row.type.active && row.reason.active && row.cause.active && row.product.active ? (
                            <span>{row.status}</span>
                        )
                        :  <img src={inactiveIcon} title={msg("admin.relationshipTab.confirmRelationshipInactive")}
                            alt={msg("admin.relationshipTab.confirmRelationshipInactive")} width="15"/>
                }
            },
            {
                attribute: "type", label: msg("admin.relationshipTab.type"), width: '242px',
                bodyStyle: (row) => row.type.active ? '': theme.columnDisable,
                render: (row) => {
                    return <span>{row.type.name}</span>;
                }
            },

            {
                attribute: "reason", label: msg("admin.relationshipTab.reason"), width: '242px',
                bodyStyle: (row) => row.reason.active ? '' : theme.columnDisable,
                render: (row) => {
                    return <span>{row.reason.name}</span>;
                }
            },

            {
                attribute: "cause", label: msg("admin.relationshipTab.cause"), width: '242px',
                bodyStyle: (row) => row.cause.active ? '' : theme.columnDisable,
                render: (row) => {
                    return <span>{row.cause.name}</span>;

                }
            },

            {
                attribute: "product", label: msg("admin.relationshipTab.product"), width: '242px',
                bodyStyle: (row) => row.product.active ? '' : theme.columnDisable,
                render: (row) => {
                    return <span>{row.product.name}</span>;
                }
            },

            {
                attribute: "action", label: msg("admin.relationshipTab.columnAction"), width: '130px', headStyle: theme.columnAction, bodyStyle: classnames(theme.columnAction, theme.txtCenter),
                render: (row, index) => {
                    return (
                        <a href="javascript:void(0)" onClick={this.handleDeleteRow(row, index)} title={msg("admin.relationshipTab.deleteItem")}>
                            <img src={deleteIcon} alt=""/>
                        </a>
                    )
                }
            }
        ];

        this.elementOrder = {
            type : "type-select",
            reason: "reason-select",
            cause: "cause-select",
            product: "product-select"
        };
    };

    clearFilter = () => {
        this.setState({
                filterApplied: false,
                type: "",
                reason: "",
                cause: "",
                product: ""
            }
        );
    };

    applyFilter = () => {
        this.setState({
            filterApplied: true
        });
    };

    getRelationships = () => {
        if (this.state.filterApplied) {
            const {type, cause, reason, product} = this.state;
            return this.state.relationships.filter(o => {
                    let typeResult = type ? type === o.type.name : true;
                    let reasonResult = reason ? reason === o.reason.name : true;
                    let causeResult = cause ? cause === o.cause.name : true;
                    let productResult = product ? product === o.product.name : true;
                    return typeResult && reasonResult && causeResult && productResult;
                }
            );
        } else {
            return this.state.relationships;
        }
    };

    reloadData = () => {
        this.setState({processing: true});

        this.request('get', conf.rest.parameterEndpoint).send((response) => {
            const types = new Map((response.body["complaintTypes"]).sort((a, b) => a.name.localeCompare(b.name)).map(o => [o.name, o.name]));
            const reasons = new Map((response.body["complaintReasons"]).sort((a, b) => a.name.localeCompare(b.name)).map(o => [o.name, o.name]));
            const causes = new Map((response.body["complaintCauses"]).sort((a, b) => a.name.localeCompare(b.name)).map(o => [o.name, o.name]));
            const products = new Map((response.body["complaintProducts"]).sort((a, b) => a.name.localeCompare(b.name)).map(o => [o.name, o.name]));
            this.setState({
                    types: types,
                    reasons: reasons,
                    causes: causes,
                    products: products,
                }
            );
            this.request('get', conf.rest.relationshipEndpoint).send((result) => {
                this.sortRelationships(result.body);
                this.setState({
                        relationships: result.body,
                        errorMessages: {},
                        type: "",
                        reason: "",
                        cause: "",
                        product: "",
                        filterApplied: false,
                        dataChanged: false,
                        processing: false
                    }
                );
            });
        });
    };

    handleSaveButtonClick = () => {
        if (this.state.dataChanged) {
            this.setState({processing: true});
            this.request('post', conf.rest.relationshipEndpoint).params(this.state.relationships).send((result) => {
                this.sortRelationships(result.body);
                this.setState({
                    relationships: result.body,
                    processing: false,
                    dataChanged: false
                });
            }, () => {
                const validationResult = new ValidationResult(this.state.errorMessages);
                validationResult.setError("update", msg("common.technicalError"));
                this.setState({
                    errorMessages: validationResult.getErrorMessages(),
                    processing: false
                });
            });
        }
    };

    handleDeleteRow = (row, index) => () => {
        if (confirm(msg("admin.relationshipTab.confirmDeleteRelationship"))) {
            if (row.status !== 'New') {
                this.setState({processing: true});
                this.request('get', conf.rest.checkrelationshipEndpoint + '/' + this.state.relationships[index].id).send((response) => {
                    if (response.body) {
                        const updated = this.state.relationships.filter(o => o.id !== row.id);
                        this.setState({
                            relationships: updated,
                            dataChanged: true,
                            errorMessages: {},
                            processing: false
                        });
                    } else {
                        let errorText = msg("admin.relationshipTab.relationshipInUse");
                        const validationResult = new ValidationResult(this.state.errorMessage);
                        validationResult.setError("update", errorText);
                        this.setState({
                            errorMessages: validationResult.getErrorMessages(),
                            processing: false
                        });
                    }
                });
            } else {
                const updated = update(this.state.relationships, {$splice: [[index, 1]]});
                this.setState({
                    relationships: updated,
                    dataChanged: true,
                    errorMessages: {}
                });
            }
        }
    };

    handleNewRowClick = () => {
        let validationResult = validate(this, this.validation, ["main"]);
        const type =  {name : this.state.type, active: true};
        const reason =  {name : this.state.reason, active: true};
        const cause =  {name : this.state.cause, active:true};
        const product =  {name : this.state.product, active: true};
        if (validationResult.isEmpty()) {
            const newRelationship = {
                status: 'New',
                type: type,
                reason: reason,
                cause: cause,
                product: product
            };
            const updated = update(this.state.relationships, {$unshift: [newRelationship]});
            this.setState({
                relationships: updated,
                dataChanged: true,
                errorMessages: {}
            });
        } else {
            let newErrorMessages = validationResult.getErrorMessages();
            this.setState({
                errorMessages: newErrorMessages
            });
            focusFirstError(this.elementOrder, newErrorMessages);
        }
    };

    handleResetButtonClick = () => {
        if (!this.state.dataChanged || confirm(msg("admin.confirmResetChanges"))) {
            this.reloadData();
        }
    };

    checkDuplicate = () => {
        let errors = [];
        if (this.state.relationships.some(
                o => (o.type.name === this.state.type
                && o.reason.name === this.state.reason
                && o.cause.name === this.state.cause
                && o.product.name === this.state.product)
            )) {
            errors.push(msg('admin.relationshipTab.duplicateValueError'));
        }
        return generateStrategyResult(errors);
    };

    sortRelationships(relationships) {
        relationships.sort((a, b) => {
                if (a.type.name !== b.type.name) {
                    return a.type.name.localeCompare(b.type.name);
                } else if (a.reason.name !== b.reason.name) {
                    return a.reason.name.localeCompare(b.reason.name);
                } else if (a.cause.name !== b.cause.name) {
                    return a.cause.name.localeCompare(b.cause.name);
                } else if (a.product.name !== b.product.name) {
                    return a.product.name.localeCompare(b.product.name);
                } else {
                    return 0;
                }
            }
        );
    }

    getValidation() {
        return {
            main: [
                {
                    individualNames: ["type", "reason", "cause", "product"],
                    strategies: [
                        this.checkDuplicate
                    ]
                },
                {
                    properties: ["state.type"],
                    individualNames: ["type"],
                    strategies: [
                        required(msg("admin.relationshipTab.emptyField")),
                    ]
                }, {
                    properties: ["state.reason"],
                    individualNames: ["reason"],
                    strategies: [
                        required(msg("admin.relationshipTab.emptyField"))
                    ]
                },
                {
                    properties: ["state.cause"],
                    individualNames: ["cause"],
                    strategies: [
                        required(msg("admin.relationshipTab.emptyField"))
                    ]
                }, {
                    properties: ["state.product"],
                    individualNames: ["product"],
                    strategies: [
                        required(msg("admin.relationshipTab.emptyField"))
                    ]
                }
            ]
        };
    };

    render() {
       const relationships = this.getRelationships();
        return (
            <div className={theme.relationshipTab}>
                <ErrorBox groups={["main", "update"]} errorMessages={this.state.errorMessages}/>
                <div className={theme.tblWrap}>
                    <div className={theme.tblWrapInner}>
                        <Table structure={this.tableStructure} firstRowStructure={this.firstRowStructure}
                            value={relationships} className={theme.relationshipTabTbl}/>
                    </div>
                </div>
                <div className={theme.btnGroupMini + " " + theme.btnAdmin}>
                    <span>{msg("admin.relationshipTab.changeBtnsInfo")}</span>
                    <button onClick={this.handleResetButtonClick}>{msg("admin.relationshipTab.resetChangesBtn")}</button>
                    <button onClick={this.handleSaveButtonClick} className={theme.buttonAccent}>{msg("admin.relationshipTab.saveChangesBtn")}</button>
                </div>
                <ProgressBar hidden={!this.state.processing} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Admin/RelationshipTab/index.js